import { HStack } from '@direct-frontend/components';
import { Outlet } from '@direct-frontend/modules-router';
import { SettingsNavMenuSuspense } from './SettingsNavMenuSuspense';
import styles from './DashboardLayout@desktop.module.css';

export const SettingsLayout = () => (
    <>
        <HStack className={styles.containerSettings} gap="8">
            <SettingsNavMenuSuspense />

            <main className={styles.content}>
                <div className={styles.innerContent}>
                    <Outlet />
                </div>
            </main>
        </HStack>
    </>
);
